import axios from "axios";

export const MODAL_REQUEST_TIMEOUT_MS = 15_000;

export type ModalLoadError = "authExpired" | "timeout" | "serverError" | null;

export function classifyModalError(err: unknown): Exclude<ModalLoadError, null> {
  if (axios.isAxiosError(err)) {
    if (err.response?.status === 401) return "authExpired";
    if (err.code === "ECONNABORTED" || err.message?.includes("timeout")) {
      return "timeout";
    }
  }
  if (err instanceof DOMException && err.name === "TimeoutError") {
    return "timeout";
  }
  if (err instanceof Error && /timed out/i.test(err.message)) {
    return "timeout";
  }
  return "serverError";
}

export async function withModalTimeout<T>(
  promise: Promise<T>,
  timeoutMs: number = MODAL_REQUEST_TIMEOUT_MS
): Promise<T> {
  return Promise.race([
    promise,
    new Promise<T>((_, reject) => {
      window.setTimeout(
        () => reject(new Error("Request timed out")),
        timeoutMs
      );
    }),
  ]);
}

export function isAuthHttpError(err: unknown): boolean {
  return axios.isAxiosError(err) && err.response?.status === 401;
}
